import { deriveThemeAccent, THEME_BRANDS, type ThemeName } from './tokens';

/** Sets the brand theme.css derives from, plus the ink it cannot derive without `contrast-color()`. */
export const applyTheme = (theme: ThemeName) => {
  const brand = THEME_BRANDS[theme];
  const { foreground } = deriveThemeAccent(brand);

  const root = document.documentElement;
  root.style.setProperty('--brand', brand);
  root.style.setProperty('--primary-foreground', `light-dark(${foreground.light}, ${foreground.dark})`);
};
